import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-02_01",
  version: "2026.06.02",
  date: "2 Jun 2026",
  sinceCommit: "47f23f3",
  gameplay: [
    { text: "Item cap: each player can own at most 6 items per match (stackables still stack within the cap)." },
  ],
  skills: [
    {
      spellId: "illusionist",
      changes: [{
        text: "New spell (slot 4): spawn decoys that mimic you, move around, soak hits, and vanish after 10 seconds.",
      }],
    },
    {
      spellId: "blizzard",
      changes: [{
        text: "New spell (slot 4): conjure a blizzard at your cursor — icy shards rain for 5s (38 DPS ticks, chill). Zone widens +25 per upgrade level.",
      }],
    },
    {
      spellId: "frostnova",
      changes: [{
        text: "New spell (slot 2, replaces Scourge): instant frost burst around you. Freezes enemies in place (no damage); frozen foes cannot Teleport or Thrust. Each level: −1s cooldown, +10 range, +0.2s freeze.",
      }],
    },
    {
      spellId: "voidbeam",
      changes: [{
        text: "New spell (slot 3): hold to charge a void line along your aim. Longer charge reaches farther and hits wider; release early for a weaker blast or hold to max (auto-fires at full charge). 118 damage, 0.28s stun at full charge.",
      }],
    },
    {
      spellId: "voidrip",
      changes: [{
        text: "New spell (slot W): tear open the arena at your cursor. After a brief arm it pulls victims inward and drains void damage — you are affected too. Each upgrade widens the rip.",
      }],
    },
  ],
};
